import {
  styled,
  Dialog,
  dialogClasses,
  IconButton,
  Alert,
} from '@mui/material';

export const DialogModifyAssignmentOrdersContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
    minHeight: 360,
  },
});

export const DialogModifyAssignmentOrdersLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogModifyAssignmentOrdersTitle = styled('div')(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogModifyAssignmentOrdersTitleCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogModifyAssignmentOrdersAlert = styled(Alert)(({ theme }) => ({
  border: `1px solid ${theme.palette.info.light}`,
  ...theme.typography.caption,
}));
